import classnames from 'classnames';
import * as _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Nav, NavItem, NavLink } from 'reactstrap';

import { clearSelectedIngredients } from 'acds-redux-core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { clearCodes } from '../../redux/actions/physician';
import ScrollBox from './ScrollBox';
import './LeftTabs.scss';

export default function LeftTabs ({ activeTab, setActiveTab, tabList, subTab = '' }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.account.user);
  const userGroup = _.get(user, 'groups.0.name', 'anonymous');
  const history = useHistory();

  useEffect(() => {
    setActiveTab(_.get(tabList, '[0].id'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleOpen = (tab) => {
    if (activeTab !== tab || !!subTab) setActiveTab(tab);
    if(tab === 'search' ) {
      dispatch(clearCodes());
      dispatch(clearSelectedIngredients());
      history.push('/allergen/search');
    } else if (tab === 'code-management') {
      history.push('/allergen/code-management');
    }
  };

  const navList = _.map(tabList, (tab) => {
    const tabs = [];
    let canView = true;
    const userTypes = _.get(tab, 'userTypes');
    const isSpecialTab = tab.id === 'search' || tab.id === 'code-management';
    const isActive = activeTab === tab.id;
    if (!!userTypes && _.findIndex(userTypes, (userType) => userType === userGroup) === -1) {
      canView = false;
    }
    if (canView) {
      if (tab.notNavItem) {
        tabs.push(<span key={tab.id}>{tab.name}</span>);
      } else {
        tabs.push(
          <NavItem
            className={classnames({ active: isActive && !isSpecialTab })}
            key={tab.id}
            style={{
              width: '250px',
              backgroundColor:
                tab.id === 'new-tab'
                  ? 'transparent'
                  : isSpecialTab
                  ? (isActive ? '#00889b' : '#414B4F')
                  : '',
              marginBottom: tab.id === 'new-tab' ? '0' : '2px',
              borderBottom: '#ffffff',
              marginTop: tab.id === 'new-tab' ? '0' : '',
              padding: tab.id === 'new-tab' ? '0' : '',
              marginLeft: tab.id === 'new-tab' ? '0' : '0px',
            }}
          >
            <NavLink
              onClick={() => {
                if (tab.id === 'new-tab') {
                  window.gtag('event', 'sidebar_physician_click', {
                  event_category: 'Tab Interaction',
                  event_label: 'sidebar_physician_click',
                  value: 1,
                  }); 
                } 
                else {
                  toggleOpen(tab.id);
                }
              }}
              style={{
                color: isSpecialTab ? (isActive ? '#ffffff' : '#FFFFFF') : '',
                padding: tab.id === 'new-tab' ? '0' : '',
              }}
            >
              {tab.name}
            </NavLink>
          </NavItem>,
        );
      }
    }

    return tabs;
  });

  return (
    <ScrollBox wrapperClassName="left-tabs-scroll" className="left-tabs-scroll__content">
      <Nav tabs className="left-tabs">
        {navList}
      </Nav>
    </ScrollBox>
  );
}
